// =============================================================================
// Newspaper theme — self-hosted assets (base64) + styles + masthead
// =============================================================================
// Assets are embedded (np-assets.ts) so they do NOT depend on any external host
// (Higgsfield/CloudFront). Styles are precomputed ONCE at module load (memoized
// TemplateResults) → zero per-render cost.
// =============================================================================

import { html } from 'lit';
import { NP } from './np-assets.js';

export { NP };

function buildCss(bg: string): string {
  return `
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Old+Standard+TT:wght@400;700&display=swap');
    .np-wrap { background-color:#efe6d2; background-image:url('${bg}'); background-size:cover; background-position:center; background-attachment:fixed; color:#292419; font-family:'Old Standard TT',Georgia,'Times New Roman',serif; min-height:calc(100vh - 88px); }
    .np-wrap h1,.np-wrap h2,.np-wrap h3,.np-wrap h4 { font-family:'Playfair Display',Georgia,serif !important; color:#1c170f !important; letter-spacing:.01em; }
    .np-masthead { background-image:url('${NP.MASTHEAD}'); background-repeat:no-repeat; }
    .np-divider { height:26px; background-image:url('${NP.DIVIDER}'); background-size:contain; background-position:center; background-repeat:no-repeat; opacity:.9; }
    .np-card { background:rgba(252,247,235,.82) !important; border:1px solid rgba(40,30,18,.28) !important; box-shadow:2px 2px 0 rgba(40,30,18,.08); }
    .np-btn { font-family:'Old Standard TT',Georgia,serif !important; background:rgba(252,247,235,.85) !important; border:1px solid rgba(40,30,18,.5) !important; color:#292419 !important; text-transform:none !important; }
    .np-btn:hover { background:#292419 !important; color:#f3ead4 !important; }
    .np-report { font-family:'Old Standard TT',Georgia,'Times New Roman',serif; font-size:15px; line-height:1.6; text-align:justify; color:#292419; }
    @media (min-width:768px){ .np-report { column-count:2; column-gap:2.4rem; } }
    .np-report h3,.np-report h4 { column-span:all; break-inside:avoid; border-bottom:1px solid rgba(40,30,18,.3); padding-bottom:2px; margin-top:1rem; }
    .np-report p,.np-report li { break-inside:avoid; }
    .np-report > div > p:first-of-type::first-letter { font-size:3.1em; float:left; line-height:.8; padding:.04em .1em 0 0; font-weight:900; font-family:'Playfair Display',Georgia,serif; color:#1c170f; }
    .np-report a { color:#5a3a16; text-decoration:underline; }
    .np-table { width:100%; border-collapse:collapse; margin:.8rem 0; font-size:14px; }
    .np-table th,.np-table td { border:1px solid rgba(40,30,18,.35); padding:5px 9px; text-align:left; vertical-align:top; }
    .np-table th { background:rgba(40,30,18,.09); font-family:'Playfair Display',Georgia,serif; font-weight:700; }
    .np-table tbody tr:nth-child(even) td { background:rgba(40,30,18,.035); }
    .np-report .np-table { column-span:all; break-inside:avoid; }
    .np-chart { column-span:all; break-inside:avoid; text-align:center; margin:.8rem 0; }
    .np-chart svg { max-width:100%; height:auto; }
  `;
}

const STYLE_LIGHT = html`<style>${buildCss(NP.PAPER)}</style>`;
const STYLE_DARK = html`<style>${buildCss(NP.PAPER_DARK)}</style>`;

export function newspaperStyle(bg: string = NP.PAPER) {
  return bg === NP.PAPER_DARK ? STYLE_DARK : STYLE_LIGHT;
}

export function masthead(title: string, subtitle: string) {
  return html`
    <div class="text-center" style="margin:10px 0 6px;">
      <div
        style="display:inline-block; border:3px double #1c170f; padding:12px 44px; background:rgba(252,247,235,.35);"
      >
        <div
          class="font-bold uppercase"
          style="font-family:'Playfair Display',Georgia,serif; color:#1c170f; letter-spacing:.025em; line-height:1.05; font-size:clamp(22px,4vw,40px);"
        >
          ${title}
        </div>
        <div class="uppercase" style="letter-spacing:.3em; color:#6b5c44; font-size:11px; margin-top:6px;">${subtitle}</div>
      </div>
    </div>
    <div class="np-divider mb-4" style="margin-top:8px;"></div>
  `;
}
